import * as React from 'react';

import {AnalysisType, ChartPlotStyle, DisplayOptions} from 'common/report/insights/util/types';
import {ChartType, ValueRepresentationType} from 'common/report/constants';

import {CardSnabbdom} from '../chart-card';

const BEHAVIOR = [
  {
    behavior: {
      type: `event`,
      resourceType: `events`,
      search: ``,
      profileType: null,
      filters: [],
      dataGroupId: null,
      dataset: `$mixpanel`,
    },
    measurement: {
      math: `total`,
      property: null,
      cumulative: false,
      perUserAggregation: null,
      rolling: null,
    },
  },
  {
    behavior: {
      type: `event`,
      resourceType: `events`,
      search: ``,
      profileType: null,
      filters: [],
      dataGroupId: null,
      dataset: `$mixpanel`,
    },
    measurement: {
      math: `total`,
      property: null,
      cumulative: false,
      perUserAggregation: null,
      rolling: null,
    },
  },
  {
    behavior: {
      type: `event`,
      resourceType: `events`,
      search: ``,
      profileType: null,
      filters: [],
      dataGroupId: null,
      dataset: `$mixpanel`,
    },
    measurement: {
      math: `total`,
      property: null,
      cumulative: false,
      perUserAggregation: null,
      rolling: null,
    },
  },
  {
    behavior: {
      type: `event`,
      resourceType: `events`,
      search: ``,
      profileType: null,
      filters: [],
      dataGroupId: null,
      dataset: `$mixpanel`,
    },
    measurement: {
      math: `total`,
      property: null,
      cumulative: false,
      perUserAggregation: null,
      rolling: null,
    },
  },
];

// TODO: Consolidate common fields
const chartProps = (events: string[], cardTitle?: string) => {
  const displayOptions: DisplayOptions = {
    chartType: ChartType.Bar,
    plotStyle: ChartPlotStyle.Standard,
    analysis: AnalysisType.Linear,
    value: ValueRepresentationType.Absolute,
    funnelStepsSelectedTableColumns: null,
  };

  return {
    cardTitle,
    chartOptions: {
      type: `bar`,
    },

    bookmark: {
      dashboard: {},
      params: {
        sections: {
          cohorts: [],
          filter: [],
          formula: [],
          group: [],
          show: events.map((ev, ind) => {
            return {
              ...BEHAVIOR[ind],
              name: ev,
            };
          }),
          time: [
            {
              dateRangeType: `in the last`,
              window: {
                unit: `day`,
                value: 30,
              },
              unit: `day`,
            },
          ],
        },
        columnWidths: {
          bar: {},
        },
        displayOptions,
        sorting: {},
      },
      can_view: true,
      allow_staff_override: false,
      is_superadmin: false,
    },
    chartParams: {
      computed_at: `2023-11-19T14:40:36.517040+00:00`,
      headers: [`$event`],
      date_range: {
        from_date: `2023-10-20T00:00:00-07:00`,
        to_date: `2023-11-19T06:41:48.638716-08:00`,
      },
      meta: {
        min_sampling_factor: 1,
        time_period_settings: {
          quarter_start_month: 1,
        },
        report_sections: {
          group: [],
          show: events.map((ev) => ({metric_key: ev})),
        },
      },
      series: events.reduce((acc, ev) => {
        acc[ev] = {all: Math.round(Math.random() * 10000)};
        return acc;
      }, {}),
    },
    dataGroups: null,
  };
};

// eslint-disable-next-line react/destructuring-assignment
export const BarPreview = ({events, cardTitle}: {events: string[]; cardTitle?: string}) => {
  //@ts-ignore
  return <CardSnabbdom params={chartProps(events, cardTitle)} />;
};
